"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FilterIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.35 8.26l-4.628 5.397A3 3 0 0011 15.61v4.89l-3 2v-6.89a3 3 0 00-.722-1.953L2.65 8.26A2.703 2.703 0 012 6.5a1 1 0 011-1h13a1 1 0 011 1c0 .645-.23 1.27-.65 1.76z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.905 7.441c.063-.308.095-.623.095-.941a3 3 0 00-3-3H7v-1a1 1 0 011-1h13a1 1 0 011 1v.059a2.99 2.99 0 01-.666 1.882l-2.43 3zm-2.88 4.27a3 3 0 00-.025.38v5.291L13 19.5v-3.89a1 1 0 01.24-.651l2.784-3.247z",
    opacity: ".6"
  })));
});
FilterIcon.category = 'Content';
var _default = FilterIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/FilterIcon.js
// module id = 1079
// module chunks = 0